import { LIMITS } from '@tctp/protocol';
import { type FormEvent, useState } from 'react';
import { Modal } from './Modal';

export function SitModal({ seat, defaultStack, maxStack, initialNickname, onSubmit, onClose }: {
  seat: number; defaultStack: number; maxStack: number; initialNickname: string;
  onSubmit: (v: { nickname: string; stack: number }) => void; onClose: () => void;
}) {
  const [nickname, setNickname] = useState(initialNickname);
  const [stack, setStack] = useState(String(defaultStack));
  const [error, setError] = useState<string | null>(null);
  function submit(e: FormEvent): void {
    e.preventDefault();
    const nick = nickname.trim();
    if (nick.length < 1 || nick.length > LIMITS.nicknameMax) { setError(`Nickname must be 1–${LIMITS.nicknameMax} characters`); return; }
    const amount = Number(stack);
    if (!Number.isInteger(amount) || amount < 1 || amount > maxStack) { setError(`Stack must be between 1 and ${maxStack}`); return; }
    onSubmit({ nickname: nick, stack: amount });
  }
  return (
    <Modal title={`Take seat ${seat + 1}`} onClose={onClose}>
      <form onSubmit={submit} noValidate>
        <label>Nickname<input value={nickname} onChange={e => setNickname(e.target.value)} maxLength={LIMITS.nicknameMax} autoFocus /></label>
        <label>Stack<input type="number" inputMode="numeric" min={1} max={maxStack} value={stack} onChange={e => setStack(e.target.value)} /></label>
        {error && <p className="error" role="alert">{error}</p>}
        <div className="modal-actions"><button type="submit" className="btn green">TAKE SEAT</button></div>
      </form>
    </Modal>
  );
}
